import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X, Wrench } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Gallery", path: "/gallery" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-black shadow-lg border-b-4 border-yellow-500 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/assets/imgs/Wow-Body-Logo.png"
              alt="WOW AUTOBODY Logo"
              className="h-16 w-auto transition-transform group-hover:scale-105"
              onError={(e) => {
                // Fallback to text logo if image fails to load
                console.log('Logo failed to load, using fallback');
                e.target.style.display = 'none';
                e.target.nextElementSibling.style.display = 'flex';
              }}
            />
            {/* <div className="hidden items-center space-x-3">
              <div className="bg-yellow-500 p-3 rounded-lg group-hover:bg-yellow-400 transition-colors">
                <Wrench className="h-8 w-8 text-black" />
              </div>
              <div>
                <h1 className="text-2xl font-black text-yellow-500">WOW</h1>
                <p className="text-sm text-white font-bold -mt-1">AUTOBODY</p>
              </div>
            </div> */}
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`px-4 py-2 rounded-md font-medium transition-all duration-200 ${
                  isActive(item.path)
                    ? "bg-yellow-500 text-black shadow-md"
                    : "text-white hover:text-yellow-500 hover:bg-gray-800"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Get Quote Button */}
          <div className="hidden md:block">
            <Link to="/contact">
              <Button className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all">
                Get Free Quote
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden text-yellow-500"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </Button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-600">
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`px-4 py-3 rounded-md font-medium transition-all duration-200 ${
                    isActive(item.path)
                      ? "bg-yellow-500 text-black"
                      : "text-white hover:text-yellow-500 hover:bg-gray-800"
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full mt-4 bg-red-600 hover:bg-red-700 text-white font-semibold">
                  Get Free Quote
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;